/**
 * Give the closed HubSpot launcher one clean keyboard focus stop.
 * HubSpot's cross-origin iframe contains additional hidden focus targets, so
 * the closed iframe is skipped and a transparent parent-page button is placed
 * directly over the visible launcher. The open chat remains keyboard usable.
 */
(function () {
  'use strict';

  var IFRAME_ID = 'hubspot-conversations-iframe';
  var CONTAINER_ID = 'hubspot-messages-iframe-container';
  var BUTTON_ID = 'ada-chat-open-btn';
  var OPEN_SIZE = 150;

  function iframeEl() {
    return document.getElementById(IFRAME_ID);
  }

  function containerEl() {
    return document.getElementById(CONTAINER_ID);
  }

  function isOpen() {
    var container = containerEl();
    if (!container) return false;
    var rect = container.getBoundingClientRect();
    return rect.width > OPEN_SIZE || rect.height > OPEN_SIZE;
  }

  function openChat() {
    var iframe = iframeEl();
    if (iframe) {
      iframe.removeAttribute('inert');
      iframe.removeAttribute('tabindex');
    }

    try {
      window.HubSpotConversations.widget.open();
    } catch (error) {
      return;
    }

    window.setTimeout(function () {
      var iframe = iframeEl();
      if (!iframe) return;
      iframe.removeAttribute('tabindex');
      iframe.focus();
    }, 400);
  }

  function ensureButton() {
    var button = document.getElementById(BUTTON_ID);
    if (button || !containerEl()) return button;

    button = document.createElement('button');
    button.id = BUTTON_ID;
    button.type = 'button';
    button.setAttribute('aria-label', 'Open live chat');
    button.setAttribute('aria-haspopup', 'dialog');
    button.addEventListener('click', openChat);
    document.body.appendChild(button);
    return button;
  }

  function positionButton(button) {
    var container = containerEl();
    if (!button || !container) return;
    var rect = container.getBoundingClientRect();

    // HubSpot's visible circular launcher sits at the BOTTOM-RIGHT of its
    // larger container box, so align the overlay there (not centered) to make
    // the round focus ring hug the green circle. INSET_* are nudge knobs.
    var size = 56;        // launcher diameter (px)
    var INSET_RIGHT = 18; // increase to move the ring left
    var INSET_BOTTOM = 18; // increase to move the ring up
    var styles = {
      left: rect.right - size - INSET_RIGHT + 'px',
      top: rect.bottom - size - INSET_BOTTOM + 'px',
      width: size + 'px',
      height: size + 'px'
    };

    Object.keys(styles).forEach(function (property) {
      if (button.style[property] !== styles[property]) {
        button.style[property] = styles[property];
      }
    });
  }

  function sync() {
    var iframe = iframeEl();
    var button = ensureButton();
    if (!iframe || !button) return;

    if (isOpen()) {
      iframe.removeAttribute('inert');
      iframe.removeAttribute('tabindex');
      button.hidden = true;
    } else {
      // Keep the closed third-party frame out of the tab order without
      // tabindex="-1", which is invalid when its document has focusable content.
      // The accessible overlay button remains the single chat focus stop.
      iframe.removeAttribute('tabindex');
      iframe.setAttribute('inert', '');
      button.hidden = false;
      positionButton(button);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  }

  function init() {
    schedule();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    window.addEventListener('resize', schedule);
    [500, 1500, 3000, 6000, 10000].forEach(function (delay) {
      window.setTimeout(schedule, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
